import { createSlice } from "@reduxjs/toolkit";
const user_id = localStorage.getItem("user_id");
const initialState = {
  // tasksInBoardView: [],
  tasksInBoardView: {
    completed: [],
    inProcess: [],
    pending: [],
    notStarted: [],
  },
  loading: false,
  addNewTaskModel: false,
  openUpdateTaskModal: false,
  updateTaskModelTaskId: null,
  randerGetApi: false,
  deleteModalOpen: false,
  tasksInTableView: [],
  taskView: "boardView",
  assignedTasks: "assignedToYou",
  assignToggleArea: false,
  assignedTasksRecord: [],
  assigenedByYou: false,
  assignedToYou: true,
  newTasksNotification: {
    pending: [],
    notStarted: [],
    inProcess: [],
    completed: [],
  },
  existingTask: false,
  updateTask: [],
  reRenderTableView: null,
  taskCardData: [],
  attachments: [],
  comments: [],
};

const taskandTicketSlice = createSlice({
  name: "taskAndticket",
  initialState,
  reducers: {
    setTasksInBoardView: (state, action) => {
      state.tasksInBoardView = {
        completed: action.payload.completed || [],
        inProcess: action.payload.inProcess || [],
        pending: action.payload.pending || [],
        notStarted: action.payload.notStarted || [],
      };
    },
    setUpdateTask: (state, action) => {
      if (action.payload.action === "Task is Deleted") {
        Object.keys(state.tasksInBoardView).forEach((key) => {
          state.tasksInBoardView[key] = state.tasksInBoardView[key].filter(
            (task) => task.taskId !== action.payload.existingTask.taskId
          );
        });
      } else {
        if (
          (action.payload.existingTask.createdBy == user_id &&
            state.assigenedByYou === true &&
            action.payload.assignedYou === true) ||
          (action.payload.existingTask.createdBy == user_id &&
            state.assigenedByYou === true &&
            action.payload.assignedYou === false) ||
          (action.payload.existingTask.createdBy != user_id &&
            state.assigenedByYou === false &&
            action.payload.assignedYou === false) ||
          (action.payload.existingTask.createdBy != user_id &&
            state.assigenedByYou === false &&
            action.payload.assignedYou === true)
        ) {
          const filterExistingTasks = (taskArray) => {
            return taskArray.filter((task) => {
              // return !action.payload.existingTask.some((payloadTask) => {
              //   let existing = payloadTask.taskId === task.taskId;
              //   state.existingTask = existing;
              //   return existing;
              // });
              return action.payload.existingTask.taskId != task.taskId;
            });
          };
          // Filter out old versions from each status array
          const filteredCompleted = filterExistingTasks(
            state.tasksInBoardView.completed
          );
          const filteredInProcess = filterExistingTasks(
            state.tasksInBoardView.inProcess
          );
          const filteredPending = filterExistingTasks(
            state.tasksInBoardView.pending
          );
          const filteredNotStarted = filterExistingTasks(
            state.tasksInBoardView.notStarted
          );

          if (
            action.payload &&
            typeof action.payload.existingTask === "object" &&
            action.payload.existingTask !== null
          ) {
            const { existingTask } = action.payload;
            switch (existingTask.status) {
              case "NotStarted":
                state.tasksInBoardView = {
                  completed: [...filteredCompleted],
                  inProcess: [...filteredInProcess],
                  pending: [...filteredPending],
                  notStarted: [...filteredNotStarted, existingTask],
                };
                break;
              case "InProcess":
                state.tasksInBoardView = {
                  completed: [...filteredCompleted],
                  inProcess: [...filteredInProcess, existingTask],
                  pending: [...filteredPending],
                  notStarted: [...filteredNotStarted],
                };
                break;

              case "Pending":
                state.tasksInBoardView = {
                  completed: [...filteredCompleted],
                  inProcess: [...filteredInProcess],
                  pending: [...filteredPending, existingTask],
                  notStarted: [...filteredNotStarted],
                };
                break;

              case "Completed":
                state.tasksInBoardView = {
                  completed: [...filteredCompleted, existingTask],
                  inProcess: [...filteredInProcess],
                  pending: [...filteredPending],
                  notStarted: [...filteredNotStarted],
                };
                break;

              default:
                console.warn("Unknown status:", existingTask.status);
            }
          }
        }
      }
    },
    setTasksInTableView: (state, action) => {
      state.tasksInTableView = action.payload;
    },
    addTasksInTableViewRealTime: (state, action) => {
      state.tasksInTableView.unshift(action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAddNewTaskModel: (state, action) => {
      state.addNewTaskModel = action.payload;
    },
    setOpenUpdateModal: (state, action) => {
      state.openUpdateTaskModal = action.payload;
    },
    setUpdateTaskModelTaskId: (state, action) => {
      state.updateTaskModelTaskId = action.payload;
    },
    setRanderGetApi: (state, action) => {
      state.randerGetApi = action.payload;
    },
    setDeleteModalOpen: (state, action) => {
      state.deleteModalOpen = action.payload;
    },
    setTaskView: (state, action) => {
      state.taskView = action.payload;
    },
    setAssignedTasks: (state, action) => {
      state.assignedTasks = action.payload;
    },
    setAssignedTasksRecord: (state, action) => {
      state.assignedTasksRecord = action.payload;
    },
    setAssignToggleArea: (state, action) => {
      state.assignToggleArea = action.payload;
    },
    setAssigenedByYou: (state, action) => {
      state.assigenedByYou = action.payload;
    },
    setAssignedToYou: (state, action) => {
      state.assignedToYou = action.payload;
    },

    setNewTasksNotification: (state, action) => {
      const arraysOnly = Object.values(action.payload)
        .filter((value) => Array.isArray(value) && value.length > 0)
        .flat();

      let userName = null;
      if (action.payload.assignedYou === true) {
        userName = arraysOnly[0]?.assignedBy?.fullName;
      } else {
        userName = arraysOnly[0]?.assignTo?.fullName;
      }
      state.newTasksNotification = {
        completed: action.payload.completed,
        inProcess: action.payload.inProcess,
        pending: action.payload.pending,
        notStarted: action.payload.notStarted,
        userName: userName,
        assignedYou: action.payload.assignedYou,
      };
      // Combine all payload tasks
      const allPayloadTasks = [
        ...(action.payload.completed || []),
        ...(action.payload.inProcess || []),
        ...(action.payload.pending || []),
        ...(action.payload.notStarted || []),
      ];

      // Create a function to filter out old versions of payload tasks
      if (
        (state.assigenedByYou === false &&
          action.payload.assignedYou === true) ||
        (state.assigenedByYou === true && action.payload.assignedYou === false)
      ) {
        const filterExistingTasks = (taskArray) => {
          return taskArray.filter((task) => {
            return !allPayloadTasks.some((payloadTask) => {
              let existing = payloadTask.taskId === task.taskId;
              state.existingTask = existing;
              return existing;
            });
          });
        };
        // Filter out old versions from each status array
        const filteredCompleted = filterExistingTasks(
          state.tasksInBoardView.completed
        );
        const filteredInProcess = filterExistingTasks(
          state.tasksInBoardView.inProcess
        );
        const filteredPending = filterExistingTasks(
          state.tasksInBoardView.pending
        );
        const filteredNotStarted = filterExistingTasks(
          state.tasksInBoardView.notStarted
        );
        // Update state by first removing old versions, then adding new ones
        state.tasksInBoardView = {
          completed: [
            ...(action.payload?.completed || []),
            ...filteredCompleted,
          ],
          inProcess: [
            ...(action.payload?.inProcess || []),
            ...filteredInProcess,
          ],
          pending: [...(action.payload?.pending || []), ...filteredPending],
          notStarted: [
            ...(action.payload?.notStarted || []),
            ...filteredNotStarted,
          ],
        };
      }
    },

    setReRenderTableView: (state, action) => {
      state.reRenderTableView = action.payload;
    },
    setTaskCardData: (state, action) => {
      state.taskCardData = action.payload;
    },

    setComments: (state, action) => {
      state.comments = action.payload;
    },
    removeAttachmentFromTaskCard: (state, action) => {
      const attachmentId = action.payload;

      const taskArray = Object.values(state.taskCardData || {});

      const task = taskArray[0];

      if (task && task.attachments) {
        task.attachments = task.attachments.filter(
          (att) => att.attachmentId !== attachmentId
        );
      }
    },

    removeAttachmentFromComment: (state, action) => {
      const { attachmentId, taskId, status } = action.payload;

      const setStatus =
        status === "InProcess"
          ? "inProcess"
          : status === "NotStarted"
          ? "notStarted"
          : status === "Pending"
          ? "pending"
          : "completed";
      state.tasksInBoardView[setStatus] = state?.tasksInBoardView[
        setStatus
      ]?.map((task) => {
        if (task.taskId === taskId) {
          return {
            ...task,
            attachments: task.attachments?.filter(
              (att) => att.attachmentId != attachmentId
            ),
          };
        }
        return task;
      });

      state.comments = state.comments.map((comment) => {
        if (comment.attachments?.length > 0) {
          return {
            ...comment,
            attachments: comment.attachments.filter(
              (att) => att.attachmentId !== attachmentId
            ),
          };
        }
        return comment;
      });
    },
  },
});

export const {
  setTaskCardData,
  setTasksInBoardView,
  setLoading,
  setAddNewTaskModel,
  setOpenUpdateModal,
  setUpdateTaskModelTaskId,
  setRanderGetApi,
  setDeleteModalOpen,
  setTasksInTableView,
  setTaskView,
  setAssignedTasks,
  setAttachments,
  setAssignedTasksRecord,
  setAssignToggleArea,
  setAssigenedByYou,
  setAssignedToYou,
  setNewTasksNotification,
  setUpdateTask,
  addTasksInTableViewRealTime,
  setReRenderTableView,
  addNewAttachment,
  removeAttachment,
  removeAttachmentFromComment,
  removeAttachmentFromTaskCard,
  setComments,
  comments,
} = taskandTicketSlice.actions;
export default taskandTicketSlice.reducer;
